<h1 mat-dialog-title>User Preferences</h1>
<div mat-dialog-content>
  <mat-checkbox [checked]="useFlatTagTableView" (change)="onFlatTagTableToggle($event.checked)">
    {{ userPreference.USE_FLAT_TAG_TABLE_VIEW }}
  </mat-checkbox>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onClose()">Close</button>
</div>
